import React from 'react';
import { toast } from 'react-hot-toast';

const DateRangeFilter = ({
    startDate,
    endDate,
    onChange,
    containerClassName = "flex items-center space-x-2",
    inputClassName = "pl-2 pr-2 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-agrosaf-green focus:border-transparent text-sm w-36 cursor-pointer",
    allowFutureDates = false,
    maxDate,
    minDate = undefined,
    toastErrorMsg = "To date cannot be before from date"
}) => {
    const effectiveMaxDate = maxDate !== undefined
        ? maxDate
        : (allowFutureDates ? undefined : new Date().toISOString().split('T')[0]);

    const handleStartDateChange = (e) => {
        const newStartDate = e.target.value;
        // Auto-fill end date with today's date if end date is empty or earlier than start date
        let newEndDate = endDate;
        const todayStr = effectiveMaxDate || new Date().toISOString().split('T')[0];
        if (newStartDate && (!endDate || endDate < newStartDate)) {
            newEndDate = newStartDate > todayStr ? newStartDate : todayStr;
        }
        onChange({ startDate: newStartDate, endDate: newEndDate });
    };

    const handleEndDateChange = (e) => {
        const selectedDate = e.target.value;
        if (startDate && selectedDate && selectedDate < startDate) {
            toast.error(toastErrorMsg);
            return;
        }
        onChange({ startDate, endDate: selectedDate });
    };

    const handleInputClick = (e) => {
        if (e.target.showPicker) {
            e.target.showPicker();
        }
    };

    return (
        <div className={containerClassName}>
            <div className="relative">
                <input
                    type="date"
                    value={startDate || ''}
                    onChange={handleStartDateChange}
                    onClick={handleInputClick}
                    min={minDate}
                    max={effectiveMaxDate}
                    className={inputClassName}
                    title="Start Date"
                />
            </div>
            <span className="text-gray-500 hidden sm:inline">To</span>
            <div className="relative">
                <input
                    type="date"
                    value={endDate || ''}
                    onChange={handleEndDateChange}
                    onClick={handleInputClick}
                    min={startDate || minDate}
                    max={effectiveMaxDate}
                    className={inputClassName}
                    title="End Date"
                />
            </div>
        </div>
    );
};

export default DateRangeFilter;
